import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import session from "../../../SessionHandler/session-helper";
import SettingsCard from "../SettingsCard";

const AnoLetivoCard = () => {
  const [anoLetivo, setAnoLetivo] = useState(() => session.getAnoLetivo() || "");
  const valido = /^\d{4}$/.test(String(anoLetivo));

  const clickSubmit = (event) => {
    event.preventDefault();
    if (!valido) return;
    session.setAnoLetivo(anoLetivo);
    // Os dados de todas as telas dependem do ano letivo da sessão.
    window.location.reload();
  };

  return (
    <SettingsCard title="Ano Letivo" description="Ano usado para exibir turmas, notas e frequências.">
      <Stack component="form" onSubmit={clickSubmit} direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField
          size="small"
          label="Ano Letivo"
          value={anoLetivo}
          onChange={(event) => setAnoLetivo(event.target.value.replace(/\D/g, "").slice(0, 4))}
          error={anoLetivo !== "" && !valido}
          helperText={anoLetivo !== "" && !valido ? "Informe o ano com 4 dígitos." : "A página será recarregada ao salvar."}
          slotProps={{ htmlInput: { inputMode: "numeric" } }}
        />
        <Box>
          <Button type="submit" variant="contained" disabled={!valido}>
            Salvar
          </Button>
        </Box>
      </Stack>
    </SettingsCard>
  );
};

export default AnoLetivoCard;
